import React from 'react';
import { SortDirection } from '../../types';

interface SortIconProps {
  direction: SortDirection | null;
}

export const SortIcon: React.FC<SortIconProps> = ({ direction }) => {
  if (direction === null) {
      // Render spacer to prevent layout shift
    return <span className="w-4 h-4 inline-block ml-1"></span>;
  }

  const iconPath = direction === 'asc'
    ? "M5 15l7-7 7 7" // Šipka nahoru
    : "M19 9l-7 7-7-7"; // Šipka dolů

  return (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className="h-4 w-4 inline-block ml-1 text-gray-600" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor" 
        strokeWidth={2}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d={iconPath} />
    </svg>
  );
};